export type ReconciliationConfidenceLevel = 'high' | 'medium' | 'low';
export type ReconciliationSuggestionStatus =
  | 'pending' | 'review_required' | 'edited' | 'overridden' | 'ignored'
  | 'executing' | 'executed' | 'resolved' | 'partial_success' | 'failed' | 'stale';

export interface FilterableReconciliationSuggestion {
  status: ReconciliationSuggestionStatus;
  confidence: { level: ReconciliationConfidenceLevel };
  requires_override: boolean;
  receipt_resolution?: { stale: boolean } | null;
}

export type ReconciliationFilter = 'all' | ReconciliationConfidenceLevel | 'needs_review' | 'executed';

export function confidencePercent(score: number): number {
  return Math.round(Math.max(0, Math.min(1, score)) * 100);
}

export function isSuggestionExecutable(suggestion: FilterableReconciliationSuggestion): boolean {
  return !['ignored', 'executing', 'executed', 'resolved', 'partial_success'].includes(suggestion.status);
}

export function matchesReconciliationFilter(
  suggestion: FilterableReconciliationSuggestion,
  filter: ReconciliationFilter,
): boolean {
  if (filter === 'all') return true;
  if (filter === 'high' || filter === 'medium' || filter === 'low') {
    return suggestion.confidence.level === filter;
  }
  if (filter === 'executed') {
    return ['executed', 'partial_success'].includes(suggestion.status)
      || (suggestion.status === 'resolved' && !suggestion.receipt_resolution?.stale);
  }
  if (suggestion.status === 'resolved') return !!suggestion.receipt_resolution?.stale;
  const reviewStatuses: ReconciliationSuggestionStatus[] = [
    'review_required', 'edited', 'failed', 'stale',
  ];
  return reviewStatuses.includes(suggestion.status) || suggestion.requires_override;
}
